import React from "react";
import { Tabs, Tab, Box, styled } from "@mui/material";
import PropTypes from "prop-types";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

const CustomTabItems = ({ tabs, value, handleChange }) => {
    const handleTabChange = (event, newValue) => {
        if (handleChange) {
            handleChange(event, newValue);
        }
    };
    const { getFontSize, getContainerHeight } = useResponsiveStyles();

    const CustomTabsContainer = styled(Box)(({ theme }) => ({
        ...getContainerHeight("tab-container"),
        // height: "25px",
        display: "inline-block",
        border: "1px solid #C43A29",
        borderRadius: "5px",
        backgroundColor: "white",
        ...theme.applyStyles("dark", {
            backgroundColor: "#1A2027",
        }),
    }));

    const CustomTabs = styled(Tabs)(({ theme }) => ({
        "& .MuiTabs-indicator": {
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            "& > span": {
                width: "100%",
                backgroundColor: "#E53935",
            },
        },
    }));

    const CustomTab = styled(Tab)(({ theme }) => ({
        ...getFontSize("side-bar-heading"),
        ...getContainerHeight("tab-height"),
        textTransform: "none",
        fontWeight: theme.typography.fontWeightRegular,
        color: "#939598",
        // minHeight: "20px",
        // height: "20px",
        "&.Mui-selected": {
            color: "#ED1C24",
            fontWeight: 600,
            backgroundColor: "#fef4f4",
            borderRadius: "5px",
        },
    }));

    return (
        <CustomTabsContainer>
            <CustomTabs
                value={value}
                onChange={handleTabChange}
                aria-label="custom styled tabs"
            >
                {tabs.map((tab, index) => (
                    <CustomTab key={index} label={tab.label} />
                ))}
            </CustomTabs>
        </CustomTabsContainer>
    );
};

CustomTabItems.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    value: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
};

const CustomTabContent = ({
    tabs,
    value,
    appliedFilters,
    setRequiredFilters,
}) => {
    const renderContentElm = (content) => {
        if (typeof content === "function") {
            const Component = content;
            return (
                <Component
                    appliedFilters={appliedFilters}
                    setRequiredFilters={setRequiredFilters}
                />
            );
        } else if (React.isValidElement(content)) {
            return content;
        }
        return null;
    };

    return (
        <>
            {tabs.map((tab, index) => (
                <Box key={index} hidden={value !== index}>
                    {tab.content &&
                        value === index &&
                        renderContentElm(tab.content)}
                </Box>
            ))}
        </>
    );
};

CustomTabContent.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.node.isRequired,
        })
    ).isRequired,
    value: PropTypes.number.isRequired,
    appliedFilters: PropTypes.object,
};

export { CustomTabItems, CustomTabContent };
